import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function getInitials(firstName, lastName) {
  if (!firstName && !lastName) return "?";

  const first = firstName ? firstName.charAt(0).toUpperCase() : "";
  const last = lastName ? lastName.charAt(0).toUpperCase() : "";

  return first + last;
}

export function getAvatarColor(name) {
  if (!name) return "#6b7280"; // gray-500

  const colors = [
    // "#ef4444", // red-500
    "#3b82f6", // blue-500
    // "#10b981", // green-500
    // "#f59e0b", // yellow-500
    // "#8b5cf6", // purple-500
    // "#ec4899", // pink-500
    // "#6366f1", // indigo-500
    // "#14b8a6", // teal-500
  ];

  // Simple hash function to get consistent color for same name
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }

  const index = Math.abs(hash) % colors.length;
  return colors[index];
}

export function getPhotoUrl(photoData) {
  if (!photoData) return null;

  // If it's already a base64 string, return it directly
  if (photoData.startsWith("data:image/")) {
    return photoData;
  }

  // If it's a file path, construct the URL (fallback for older data)
  const baseUrl = import.meta.env.VITE_API_URL || "http://localhost:3001";
  return `${baseUrl}/uploads/${photoData}`;
}

export function formatCurrency(amount, currency = "MAD", locale = "fr-MA") {
  if (amount === null || amount === undefined) return "N/A";

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}

export function formatDate(date, locale = "fr-FR") {
  if (!date) return "N/A";

  return new Date(date).toLocaleDateString(locale, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

export function formatDateTime(date, locale = "fr-FR") {
  if (!date) return "N/A";

  return new Date(date).toLocaleString(locale, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatTimeAgo(date, locale = "fr-FR") {
  if (!date) return "N/A";

  const now = new Date();
  const targetDate = new Date(date);
  const diffInMs = now - targetDate;

  // Convertir en différentes unités
  const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
  const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
  const diffInWeeks = Math.floor(diffInDays / 7);
  const diffInMonths = Math.floor(diffInDays / 30);
  const diffInYears = Math.floor(diffInDays / 365);

  if (diffInMinutes < 1) {
    return "À l'instant";
  } else if (diffInMinutes < 60) {
    return `Il y a ${diffInMinutes} minute${diffInMinutes > 1 ? "s" : ""}`;
  } else if (diffInHours < 24) {
    return `Il y a ${diffInHours} heure${diffInHours > 1 ? "s" : ""}`;
  } else if (diffInDays < 7) {
    return `Il y a ${diffInDays} jour${diffInDays > 1 ? "s" : ""}`;
  } else if (diffInWeeks < 4) {
    return `Il y a ${diffInWeeks} semaine${diffInWeeks > 1 ? "s" : ""}`;
  } else if (diffInMonths < 12) {
    return `Il y a ${diffInMonths} mois`;
  } else {
    return `Il y a ${diffInYears} an${diffInYears > 1 ? "s" : ""}`;
  }
}

export function truncateText(text, maxLength = 100) {
  if (!text) return "";
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + "...";
}

export function slugify(text) {
  if (!text) return "";

  return text
    .toString()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // Supprimer les accents
    .replace(/[^a-z0-9 -]/g, "") // Supprimer les caractères spéciaux
    .replace(/\s+/g, "-") // Remplacer les espaces par des tirets
    .replace(/-+/g, "-") // Supprimer les tirets multiples
    .trim("-"); // Supprimer les tirets en début/fin
}
